import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SDrawerOrModal,
} from 'shj-components'
import { Form, Input, Select, Switch, Button, message } from 'antd';
import {
  addNewPriceContract,
  getBudgetTypeEnumNew,
  getContractTypeEnum,
  getContractTemplateListAll,
  queryContractInfoDetail,
  uploadContractInfo
} from '@/services/goods.ts';
import styles from './index.module.less'

export default function ContentModal ({
  list = {},
  editId = '',
  open = false,
  contractFilterValue = '',
  contractPriceFilterValue = '',
  setContractFilterValue = (item: any) => {},
  setContractPriceFilterValue = (item: any) => {},
  onClose = () => {},
  setRule = (item: any) => {}
})  {
  const [enumData, setEnumData] = useState({
    budgetTypeList: [],
    contractTypeList: [],
  });
  const [templateList, setTemplateList] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [ form ] = Form.useForm();
  const needSign = Form.useWatch('customerSignFlag', form);
  const isOnlineTemplate = Form.useWatch('onlineFlag', form);
  const auditFlag = Form.useWatch('auditFlag', form);

  useEffect(() => {
    fetchEnumData();
    fetchContractTemplateList();
    if (editId) {
      getDetail(editId);
    }
  }, [editId]);

  useEffect(() => {
    form.setFieldValue('filterData', contractFilterValue);
  }, [contractFilterValue])

  useEffect(() => {
    form.setFieldValue('priceItemFilterRule', contractPriceFilterValue);
  }, [contractPriceFilterValue])

  const fetchEnumData = async () => {
    try {
      const contractRes: any = await getContractTypeEnum();
      const budgetRes: any = await getBudgetTypeEnumNew();
      let contractTypeList = [];
      let budgetTypeList = [];
      if (contractRes?.length) {
        contractTypeList = contractRes.map(contract => ({
          label: contract?.description,
          value: contract?.key,
        }));
      }
      if (budgetRes?.length) {
        budgetTypeList = budgetRes.map(budget => ({
          label: budget?.name,
          value: budget?.code,
        }));
      }
      setEnumData({
        contractTypeList,
        budgetTypeList,
      })
    } catch (err) {
      console.log(err)
    }
  };

  const fetchContractTemplateList = async () => {
    try {
      const res: any = await getContractTemplateListAll({ enable: true });
      if (res?.length) {
        const list = res.map(item => ({
          label: item.name,
          value: item.id,
        }));
        setTemplateList(list);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getDetail = async (id) => {
    try {
      setButtonLoading(true);
      const res: any = await queryContractInfoDetail(id);
      setButtonLoading(false);
      if (res?.id) {
        form.setFieldsValue({ ...res });
        setContractFilterValue(res?.filterData)
        setContractPriceFilterValue(res?.priceItemFilterRule)
      }
    } catch(err) {
      setButtonLoading(false);
      console.log(err)
    }
  }

  const onSubmit = () => {
    form.validateFields().then(async (values: any) => {
      try {
        let res: any = {};
        setButtonLoading(true);
        if (editId) { // 编辑
          res = await uploadContractInfo({
            id: editId,
            ...values,
          })
        } else { // 新增
          res= await addNewPriceContract({
            ...values,
          })
        }
        if (res?.id) {
          message.success('保存成功');
          setButtonLoading(false);
          (list as any)?.current?.reload();
          onClose();
        } else {
          setButtonLoading(false);
          message.error('保存失败');
          return;
        }
      } catch (err) {
        setButtonLoading(false);
        console.log(err)
      }
    })
  }

  const MyRule = ({ type = 'goodsContractFilterRule' }) => {
    return (
    <div>
      <Button onClick={() => setRule({open: true, type})}>编辑规则</Button>
    </div>
  )};

  return (
    <div className={styles.settlementQuotaConfig}>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={buttonLoading}
        width="40%"
      >
        <Form
          form={form}
          labelCol={{
            span: 12,
          }}
          layout="vertical"
          name="basicInfo"
        >
          <Form.Item
            name="title"
            label="合同标题"
            rules={[
              {
                required: true,
                message: '请选择合同标题',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="quoteType"
            label="报价类型"
            rules={[
              {
                required: true,
                message: '请填写报价类型',
              },
            ]}
          >
            <Select disabled={ editId ? true: false } options={enumData?.budgetTypeList}></Select>
          </Form.Item>
          <Form.Item
            name="contractType"
            label="合同类型"
            rules={[
              {
                required: true,
                message: '请填写合同类型',
              },
            ]}
          >
            <Select disabled={ editId ? true: false } showSearch optionFilterProp='label' options={enumData?.contractTypeList} />
          </Form.Item>
          <Form.Item
            name="displayFlag"
            label="是否显示"
            rules={[
              {
                required: true,
                message: '请选择是否显示',
              },
            ]}
            valuePropName='checked'
            initialValue={true}
          >
            <Switch checkedChildren="是" unCheckedChildren="否" />
          </Form.Item>
          <Form.Item
            name="onlineFlag"
            label="是否在线模板"
            rules={[
              {
                required: true,
                message: '请选择是否在线模板',
              },
            ]}
            valuePropName='checked'
            initialValue={true}
          >
            <Switch checkedChildren="是" unCheckedChildren="否" />
          </Form.Item>
          {
            isOnlineTemplate && (
              <>
                <Form.Item
                  name="printTemplateId"
                  label="关联的合同模板"
                  rules={[
                    {
                      required: true,
                      message: '请选择关联的合同模板',
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    options={templateList}
                  />
                </Form.Item>
              </>
            )
          }
          <Form.Item
            name="auditFlag"
            label="合同是否需审核"
            rules={[
              {
                required: true,
                message: '请选择合同是否需审核',
              },
            ]}
            valuePropName='checked'
            initialValue={true}
          >
            <Switch checkedChildren="是" unCheckedChildren="否" />
          </Form.Item>
          {
            auditFlag ? (
              <Form.Item
                name="longTailReviewFlag"
                label="是否长尾审核"
                rules={[
                  {
                    required: true,
                    message: '请选择是否长尾审核',
                  },
                ]}
                valuePropName='checked'
                initialValue={false}
              >
                <Switch checkedChildren="是" unCheckedChildren="否" />
              </Form.Item>
            ) : null
          }
          <Form.Item
            name="customerSignFlag"
            label="是否需要客户签字"
            rules={[
              {
                required: true,
                message: '请选择是否需要客户签字',
              },
            ]}
            valuePropName='checked'
            initialValue={false}
          >
            <Switch checkedChildren="是" unCheckedChildren="否" />
          </Form.Item>
          {
            needSign && (
              <>
                {
                  isOnlineTemplate && (
                    <>
                      <Form.Item
                        name="onlineSignFlag"
                        label="是否在线签"
                        rules={[
                          {
                            required: true,
                            message: '请选择是否在线签',
                          },
                        ]}
                        valuePropName='checked'
                        initialValue={true}
                      >
                        <Switch checkedChildren="是" unCheckedChildren="否" />
                      </Form.Item>
                    </>
                  )
                }
              </>
            )
          }
          {
            isOnlineTemplate && (
              <>
                <Form.Item
                  name="startAgainFlag"
                  label="是否可多次发起"
                  rules={[
                    {
                      required: true,
                      message: '请选择是否可多次发起',
                    },
                  ]}
                  valuePropName='checked'
                  initialValue={false}
                >
                  <Switch checkedChildren="是" unCheckedChildren="否" />
                </Form.Item>
                <Form.Item
                  name="filterData"
                  label="过滤产品"
                >
                  <MyRule type="goodsContractFilterRule" />
                </Form.Item>
                <Form.Item
                  name="priceItemFilterRule"
                  label="过滤费用"
                >
                  <MyRule type="goodsContractPriceItemFilterRule" />
                </Form.Item>
              </>
            )
          }
          <Form.Item
            name="tmallMainFlag"
            label="是否天猫主合同"
            rules={[
              {
                required: true,
                message: '请选择是否天猫主合同',
              },
            ]}
            valuePropName='checked'
            initialValue={false}
          >
            <Switch checkedChildren="是" unCheckedChildren="否" />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
